import http from '../../../lib/http'
import { notify } from '../../../lib/Notification/actions.js'
import { getPatientBanner } from '../PatientBanner/actions.js'

export const SHOW_CASE_MANAGEMENT_MODAL = 'SHOW_CASE_MANAGEMENT_MODAL'
export const HIDE_CASE_MANAGEMENT_MODAL = 'HIDE_CASE_MANAGEMENT_MODAL'

export const UPDATE_CASE = 'UPDATE_CASE'
export const UPDATE_CASE_SUCCESS = 'UPDATE_CASE_SUCCESS'
export const UPDATE_CASE_FAILURE = 'UPDATE_CASE_FAILURE'

export function showCaseManagementModal () {
  return dispatch => {
    dispatch({ type: SHOW_CASE_MANAGEMENT_MODAL })
  }
}

export function hideCaseManagementModal () {
  return dispatch => {
    dispatch({ type: HIDE_CASE_MANAGEMENT_MODAL })
  }
}

export function updateHistoryNote (id, note, cb) {
  return (dispatch, getState) => {
    const {
      globalVars: {
        params: { id: patientId }
      }
    } = getState()
    return http
      .putRequest(`/patients/${patientId}/cases/current/history`, {
        id,
        note
      })
      .then(() => {
        cb()
        dispatch(notify('Note was updated', false))
        dispatch(getPatientBanner())
      })
      .catch(() => dispatch(notify('Note update error', false)))
  }
}

export function updateOrganization (formData) {
  return (dispatch, getState) => {
    const {
      globalVars: {
        params: { id: patientId }
      }
    } = getState()
    dispatch({ type: UPDATE_CASE })
    dispatch({ type: HIDE_CASE_MANAGEMENT_MODAL })
    if (formData.par === undefined) {
      delete formData.par
    }
    return http
      .putRequest(`/patients/${patientId}/cases/current/organization`, formData)
      .then(response => {
        dispatch(notify('Organization was successfully updated', false))
        dispatch({
          type: UPDATE_CASE_SUCCESS,
          data: response
        })
        dispatch(getPatientBanner())
      })
      .catch(err =>
        dispatch({
          type: UPDATE_CASE_FAILURE,
          error: err
        }))
  }
}

export function updateCase (formData) {
  return (dispatch, getState) => {
    const {
      globalVars: {
        params: { id: patientId }
      }
    } = getState()
    dispatch({ type: UPDATE_CASE })
    dispatch({ type: HIDE_CASE_MANAGEMENT_MODAL })
    if (formData.par === undefined) {
      delete formData.par
    }
    return http
      .putRequest(`/patients/${patientId}/cases/current/update`, formData)
      .then(response => {
        dispatch(notify('Case status was successfully updated', false))
        dispatch({
          type: UPDATE_CASE_SUCCESS,
          data: response
        })
        dispatch(getPatientBanner())
      })
      .catch(err =>
        dispatch({
          type: UPDATE_CASE_FAILURE,
          error: err
        }))
  }
}
